import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { STATIC } from '../../lib/queryPresets';
import { useAuthStore } from '../../store/useAuthStore';
import {
  getMyGoogleConnection, disconnectGoogle,
} from '../../services/googleSync/googleSyncService';

export function useGoogleCalendarConnection() {
  const collaboratorId = useAuthStore((s) => s.collaborator?.id);
  return useQuery({
    ...STATIC,
    queryKey: ['google-calendar', 'connection', collaboratorId],
    queryFn: () => getMyGoogleConnection(collaboratorId!),
    enabled: !!collaboratorId,
  });
}

export function useDisconnectGoogle() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: disconnectGoogle,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['google-calendar', 'connection'] }),
    onError: () => toast.error('Déconnexion échouée. Réessayez.'),
  });
}
